import React from "react";
import Cards from "./Cards";

const HomePage = () => {
  return (
    <>
      <div className="outer-wrapper">
        <Cards />
      </div>
    </>
  );
};

export default HomePage;
